<dx-tab-panel
    [showNavButtons]="true"
>
    <dxi-item title="TransactionDetail">
        <div *dxTemplate="let data of 'transactionDetail'">
        <dx-data-grid
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [dataSource]="transactionDetailData"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true">

            <dxi-column dataField="ReportName" [width]="140"></dxi-column>
            <dxi-column dataField="DataProviderName" [width]="200"></dxi-column>
            <dxi-column dataField="SourceSalonId" [width]="300"></dxi-column>
            <dxi-column dataField="Date" [width]="200" dateSerializationFormat="yyyy-MM-dd"></dxi-column>
            <dxi-column dataField="Quantity" [width]="140"></dxi-column>
            <dxi-column dataField="Revenue" caption="Revenue" [width]="140"></dxi-column>
            <!-- <dxi-column dataField="Revenue" caption="Unit Price" [width]="140"></dxi-column> -->
            <dxi-column dataField="CurrencyAlphabeticCode"></dxi-column>
            <dxo-paging [pageSize]="10"></dxo-paging>
        </dx-data-grid>
        </div>
    </dxi-item>
</dx-tab-panel>
<!--<dx-data-grid-->
<!--  [allowColumnResizing]="true"-->
<!--  [columnResizingMode]="'widget'"-->
<!--  [dataSource]="transactionDetailData"-->
<!--  [showBorders]="true"-->
<!--  [columnAutoWidth]="true"-->
<!--  [remoteOperations]="true">-->

<!--  <dxi-column dataField="ReportName" [width]="140"></dxi-column>-->
<!--  <dxi-column dataField="DataProviderName" [width]="200"></dxi-column>-->
<!--  <dxi-column dataField="SourceSalonId" [width]="300"></dxi-column>-->
<!--  <dxi-column dataField="Date" [width]="200" dateSerializationFormat="yyyy-MM-dd"></dxi-column>-->
<!--  <dxi-column dataField="Quantity" [width]="140"></dxi-column>-->
<!--  <dxi-column dataField="Revenue" caption="Revenue" [width]="140"></dxi-column>-->
<!--  &lt;!&ndash; <dxi-column dataField="Revenue" caption="Unit Price" [width]="140"></dxi-column> &ndash;&gt;-->
<!--  <dxi-column dataField="CurrencyAlphabeticCode"></dxi-column>-->
<!--  <dxo-paging [pageSize]="10"></dxo-paging>-->
<!--</dx-data-grid>-->
